module.exports = __webpack_public_path__ + "img/dailyReport.31c1f5b9.png";